import { render, staticRenderFns } from "./AutomacaoEditorApp.vue?vue&type=template&id=41d2f244"
import script from "./automacao-editor.js?vue&type=script&lang=js&external"
export * from "./automacao-editor.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports